import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';
import COMMON_CONSTANTS from '../../../../constants/commonConstants';

const MobileIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={{ width: 'auto', height: 'auto', ...sx }}
  >
    <svg
      width="75"
      height="75"
      viewBox="0 0 75 75"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="37.2371"
        cy="37.2371"
        r="35.9072"
        fill={COMMON_CONSTANTS?.COLOR_PALETTE?.SECONDARY}
        stroke="none"
        strokeWidth="2.65979"
      />
      <g clipPath="url(#clip0_7135_2339)">
        <path
          d="M24.5 20.3615V53.64C24.5 55.8787 26.3614 57.7008 28.6483 57.7008H47.3517C49.6386 57.7008 51.5 55.8787 51.5 53.64V20.3615C51.5 18.1229 49.6386 16.3008 47.3517 16.3008H28.6483C26.3614 16.3008 24.5 18.1229 24.5 20.3615ZM28.6483 17.923H47.3517C48.7253 17.923 49.8428 19.017 49.8428 20.3615V53.64C49.8428 54.9846 48.7253 56.0785 47.3517 56.0785H28.6483C27.2747 56.0785 26.1572 54.9846 26.1572 53.64V20.3615C26.1572 19.017 27.2747 17.923 28.6483 17.923Z"
          fill="white"
        />
        <path
          d="M31.4084 48.6262H44.5901C46.2923 48.6262 47.6762 47.2715 47.6762 45.6052V22.8257C47.6762 21.1594 46.2923 19.8047 44.5901 19.8047H31.4084C29.7062 19.8047 28.3223 21.1594 28.3223 22.8257V45.6052C28.3223 47.2715 29.7062 48.6262 31.4084 48.6262ZM29.6474 22.8257C29.6474 21.874 30.4362 21.1018 31.4084 21.1018H44.5901C45.5623 21.1018 46.3511 21.874 46.3511 22.8257V45.6052C46.3511 46.5569 45.5623 47.3291 44.5901 47.3291H31.4084C30.4362 47.3291 29.6474 46.5569 29.6474 45.6052V22.8257Z"
          fill="white"
        />
        <path
          d="M38 49.6602C36.4397 49.6602 35.1699 50.9031 35.1699 52.4305C35.1699 53.958 36.4397 55.2009 38 55.2009C39.5604 55.2009 40.8301 53.958 40.8301 52.4305C40.8301 50.9031 39.5604 49.6602 38 49.6602ZM38 54.2289C36.9863 54.2289 36.1629 53.4229 36.1629 52.4305C36.1629 51.4382 36.9863 50.6322 38 50.6322C39.0137 50.6322 39.8371 51.4382 39.8371 52.4305C39.8371 53.4229 39.0137 54.2289 38 54.2289Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_7135_2339">
          <rect
            width="27"
            height="41.4"
            fill="white"
            transform="translate(24.5 16.3008)"
          />
        </clipPath>
      </defs>
    </svg>
  </StyledSvgIcon>
);
export default MobileIcon;

MobileIcon.propTypes = customIconsPropTypes;
